var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M3.866 8.392L5.233 7.05a.627.627 0 0 1 .875 0 .6.6 0 0 1 0 .858L4.74 9.25l1.367 1.341a.6.6 0 0 1 0 .859.627.627 0 0 1-.875 0l-1.367-1.341-1.366 1.34a.627.627 0 0 1-.875 0 .6.6 0 0 1 0-.858l1.366-1.34-1.366-1.342a.6.6 0 0 1 0-.858.627.627 0 0 1 .875 0l1.366 1.34zm3.199 5.561H19.38c.342 0 .619.272.619.608a.613.613 0 0 1-.619.607H5.691a107.82 107.82 0 0 1-2.681 2.25c-.267.216-.458.368-.561.449a.627.627 0 0 1-.87-.095.6.6 0 0 1 .097-.853 97.298 97.298 0 0 0 2.133-1.75l-3.19-.001A.613.613 0 0 1 0 14.56c0-.336.277-.608.619-.608H5.22a88.303 88.303 0 0 0 3.408-3.142c-.363-.822-.522-1.93-.481-3.2.078-2.468.899-5.01 2.137-6.225 3.668-3.6 6.954.43 3.839 5.015-.645.95-1.494 1.99-2.521 3.11-.43.469-.888.948-1.372 1.437.15.114.315.173.492.173.746 0 1.35-.246 2.303-.847 1.084-.684 1.017-.644 1.404-.807 1.435-.607 2.672-.065 4.024 1.925a.6.6 0 0 1-.172.842.626.626 0 0 1-.858-.169c-1.05-1.547-1.69-1.827-2.505-1.483-.29.123-.24.093-1.224.713-1.136.717-1.93 1.04-2.972 1.04-.55 0-1.01-.18-1.382-.506a85.29 85.29 0 0 1-2.275 2.125zM10.682 8.7c.99-1.08 1.803-2.077 2.411-2.972 2.396-3.526.492-5.862-1.934-3.482-.977.959-1.706 3.216-1.775 5.403-.028.88.051 1.623.213 2.195.38-.389.742-.77 1.085-1.144z", id: "svg1337666103a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(0 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg1337666103b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg1337666103a" })
      ),
      React.createElement("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#svg1337666103a" }),
      React.createElement(
        "g",
        { mask: "url(#svg1337666103b)" },
        React.createElement("path", { d: "M-1-1h22v20H-1z" })
      )
    )
  );
});